import { localStorageAdapter } from "./LocalStorageAdapter";
import { Base64 } from "js-base64";

const storageSize = 40;
const storageSizeQueryParam = 20;
const storageName = "continue_watching";
const localStorage = localStorageAdapter(storageName);

export class ContinueWatchingStorage {
  static get() {
    try {
      return JSON.parse(localStorage.getItem(storageName)) || [];
    } catch (e) {
      return [];
    }
  }

  static toQueryParam() {
    let localContents = this.get().slice(0, this.storageSizeQueryParam());
    let transformedContents = localContents.map((content) => {
      return {
        id: content.id,
        type: "video",
        time: content.time || 0,
        last_played_at: Math.round(content.timestamp / 1000),
      };
    });
    let encodedContents = Base64.encode(JSON.stringify(transformedContents));

    return `contents=${encodedContents}`;
  }

  static update(newContents) {
    let localContents = this.get();

    newContents.forEach((newContent) => {
      let currentContent = localContents.find(content => content.id === newContent.content_id);

      if (currentContent) {
        currentContent.time = newContent.watch_duration;
        currentContent.timestamp = Date.parse(newContent.last_played_at);
        currentContent.filmId = newContent.content_profile_id

        this._sortByTimestamp(localContents);
      } else {
        let transformedNewData = {
          id: newContent.content_id,
          type: newContent.content_type,
          time: newContent.watch_duration,
          isPremier: newContent.is_premier,
          timestamp: Date.parse(newContent.last_played_at),
          filmId: newContent.content_profile_id
        };
        localContents.unshift(transformedNewData);
      }
    });

    let updatedContents = localContents.slice(0, this.storageSize());

    localStorage.setItem(storageName, JSON.stringify(updatedContents));
  }

  static _sortByTimestamp(videos) {
    return videos.sort((a, b) => {
      if (!a.timestamp && !b.timestamp) {
        return 0;
      } else if(!a.timestamp) {
        return 1;
      } else if(!b.timestamp) {
        return -1;
      } else {
        return b.timestamp - a.timestamp;
      }
    });
  }

  static storageSize() {
    return storageSize;
  }

  static storageSizeQueryParam() {
    return storageSizeQueryParam;
  }
}
